import { Controller } from '@hotwired/stimulus';
import SET_MAP from '../../utils/mapbox/config/setMap';
import SET_MARKERS from '../../utils/mapbox/config/setMarkers';
import SET_POPUP from '../../utils/mapbox/config/setPopup';

export default class extends Controller {
  static values = {
    url: String,
    zones: Array,
    cta: String,
    publicKey: String,
    style: String
  };

  static targets = ['searchInput', 'dropdown', 'map'];

  connect() {
    this.map = null;
    this.initMapbox();
    this.handleClickOutside = this.hideDropdown.bind(this);
    document.addEventListener('click', this.handleClickOutside);
  }

  disconnect() {
    document.removeEventListener('click', this.handleClickOutside);
  }

  initMapbox() {
    this.map = SET_MAP.initMap(
      this.publicKeyValue,
      [1.7191, 47.7833],
      4.5,
      this.styleValue,
      this.mapTarget
    );

    this.map.on('load', () => {
      this.map.setLayoutProperty('country-label', 'text-field', ['get', 'name_fr']);
      this.map.setLayoutProperty('state-label', 'text-field', ['get', 'name_fr']);
      this.map.setLayoutProperty('settlement-subdivision-label', 'text-field', ['get', 'name_fr']);
    });

    this.map.doubleClickZoom.disable();

    this.zonesValue.forEach((zoneInfos) => {
      const popup = this.createPopup(zoneInfos[2]);
      SET_MARKERS.main(this.map, [zoneInfos[1], zoneInfos[0]], popup);
    });
  }

  filterZones() {
    const query = this.searchInputTarget.value.toLowerCase().trim();
    if (!query) {
      this.hideDropdown();
      return;
    }

    const filtered = this.zonesValue.filter(zone =>
      zone[2].toLowerCase().includes(query)
    );

    this.renderDropdown(filtered);
  }

  showDropdown() {
    if (this.searchInputTarget.value.trim().length > 0) {
      this.dropdownTarget.classList.remove('hidden');
    }
  }

  hideDropdown() {
    this.dropdownTarget.classList.add('hidden');
  }

  renderDropdown(zones) {
    if (zones.length === 0) {
      this.dropdownTarget.innerHTML = `
        <div class="p-4 text-sm text-center text-ih-indigo">
          Hosman n'est pas encore présent dans votre ville
        </div>
      `;
    } else {
      this.dropdownTarget.innerHTML = zones.slice(0, 20).map(zone => `
        <button class="w-full text-left px-4 py-3 text-sm hover:bg-ih-blue-5 text-ih-indigo"
                data-lat="${zone[0]}" data-lng="${zone[1]}" data-name="${zone[2]}"
                data-action="click->application--zones-page--map#selectZone">
          ${zone[2]}
        </button>
      `).join('');
    }
    this.dropdownTarget.classList.remove('hidden');
  }

  selectZone(e) {
    e.stopPropagation();
    const { lat, lng, name } = e.currentTarget.dataset;

    this.searchInputTarget.value = name;
    this.hideDropdown();

    const closePopup = document.querySelector('.mapboxgl-popup-close-button');
    if (closePopup) closePopup.click();

    this.map.flyTo({ center: [lng, lat], zoom: 12 });

    if (name) {
      this.createPopup(name).setLngLat([lng, lat]).addTo(this.map);
    }
  }

  createPopup(zoneName) {
    const popupOffsets = {
      top: [0, 0], 'top-left': [0, 0], 'top-right': [0, 0],
      bottom: [0, 0], 'bottom-left': [0, 0], 'bottom-right': [0, 0],
      left: [0, 0], right: [0, 0]
    };

    const HTMLContent = `
      <a href="${this.urlValue}" style="cursor:pointer;text-decoration:none;">
        <div style="display:flex;gap:12px;align-items:center;width:220px;">
          <img src="https://res.cloudinary.com/vesta-home/image/upload/v1642581991/assets/images/revamp%202022/images/tooltip_img.webp"
               alt="tooltip"
               style="width:64px;height:64px;object-fit:cover;border-radius:8px;flex-shrink:0;">
          <div style="display:flex;flex-direction:column;gap:4px;padding-right:8px;">
            <p style="font-weight:600;font-size:13px;color:#21175A;margin:0;">${zoneName}</p>
            <p style="font-weight:600;font-size:11px;color:#5076F6;margin:0;">${this.ctaValue}</p>
          </div>
        </div>
      </a>
    `;

    return SET_POPUP.init(popupOffsets, HTMLContent);
  }
}
